import { motion } from "framer-motion";

export const NutritionFacts = () => {
  return (
    <section 
      id="nutrition"
      className="py-24 md:py-32 bg-[#0A0A0A]"
      data-testid="nutrition-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
          {/* Left: Section info */}
          <div>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="font-mono text-sm tracking-[0.3em] text-[#E82D00] mb-4"
            >
              NUTRITION INFORMATION
            </motion.p>
            
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="text-4xl md:text-5xl font-bold uppercase tracking-tight text-white mb-8"
              style={{ fontFamily: 'Oswald, sans-serif' }}
              data-testid="nutrition-heading"
            >
              Supplement Facts
            </motion.h2>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="space-y-4 text-[#A3A3A3]"
            >
              <p className="text-lg">
                <span className="text-white font-semibold">Serving Size:</span> 1 Scoop (5g)
              </p>
              <p className="text-lg">
                <span className="text-white font-semibold">Servings Per Container:</span> 200
              </p>
            </motion.div>

            {/* Ingredients */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="mt-8 p-6 border border-white/10 bg-[#050505]"
            >
              <p className="font-mono text-xs tracking-widest text-[#E82D00] uppercase mb-3">Ingredients</p>
              <p className="text-[#E5E5E5]">Creatine Monohydrate (HPLC Pure)</p>
            </motion.div>

            {/* Note */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="mt-6 text-sm text-[#A3A3A3] font-mono"
            >
              * Nutrient Reference Values (NRVs) for individuals 4 years and older (2010). No NRV determined.
            </motion.p>
          </div>

          {/* Right: Nutrition table */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            data-testid="nutrition-table"
          >
            <div className="nutrition-table">
              {/* Header */}
              <div className="bg-white text-[#050505] px-6 py-4">
                <h3 
                  className="text-2xl font-bold uppercase tracking-tight"
                  style={{ fontFamily: 'Oswald, sans-serif' }}
                >
                  Supplement Facts
                </h3>
              </div>

              {/* Serving info */}
              <div className="border-b-4 border-white px-6 py-3">
                <p className="font-mono text-sm text-white">Serving Size: 1 Scoop (5g)</p>
              </div>

              {/* Amount per serving header */}
              <div className="border-b border-white/30 px-6 py-3 flex justify-between">
                <span className="font-mono text-xs text-[#A3A3A3] uppercase tracking-wider">Amount Per Serving</span>
                <span className="font-mono text-xs text-[#A3A3A3] uppercase tracking-wider">% NRV*</span>
              </div>

              {/* Nutrition row */}
              <div className="nutrition-row">
                <div>
                  <span className="text-white font-semibold">Creatine Monohydrate</span>
                </div>
                <div className="flex gap-8">
                  <span className="text-white font-mono">5g</span>
                  <span className="text-[#A3A3A3] font-mono w-12 text-right">**</span>
                </div>
              </div>

              {/* Footer note */}
              <div className="px-6 py-4 border-t border-white/30">
                <p className="font-mono text-xs text-[#A3A3A3]">
                  ** No NRV determined
                </p>
              </div>
            </div>

            {/* Additional info card */}
            <div className="mt-6 p-6 border border-[#616556]/30 bg-[#616556]/5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-2 h-2 bg-[#E82D00]" />
                <span className="font-mono text-xs tracking-widest text-[#616556] uppercase">HPLC Tested</span>
              </div>
              <p className="text-sm text-[#A3A3A3]">
                Every batch is tested for purity and potency using High-Performance Liquid Chromatography.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default NutritionFacts;
